import type { DashboardSummary as SummaryData } from "@/domain/dashboard/types";
import styles from "./DashboardSummary.module.css";

interface DashboardSummaryProps {
  readonly summary: SummaryData;
}

function formatTrackedTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}m tracked`;
  return `${hours}h ${mins}m tracked`;
}

export function DashboardSummaryFooter({ summary }: DashboardSummaryProps) {
  if (summary.completed === 0) return null;

  return (
    <div className={styles.wrapper}>
      <span className={styles.stat}>
        {summary.completed} of {summary.totalShifts} complete
      </span>
      {summary.onTimePercent !== null && (
        <span className={styles.stat}>
          {summary.onTimePercent}% on time
        </span>
      )}
      <span className={styles.stat}>
        {formatTrackedTime(summary.totalTrackedMinutes)}
      </span>
    </div>
  );
}
